import React from 'react'
import AdnCard from '../common/adnCard/AdnCard'
import AdnPageTitle from '../common/adnPageTitle/AdnPageTitle'
import AdnTable from '../common/adnTable/AdnTable'
import { Col, Modal, Row, Space, Form } from 'antd';
import AdnInput from '../common/adnInput/AdnInput';
import AdnAddButton from '../common/adnAddButton/AdnAddButton';
import adnYesNoModal from '../common/adnYesNoModal/AdnYesNoModal';
import { DeleteOutlined } from '@ant-design/icons';
import AdnDropdown from '../common/adnDropdown/AdnDropdown';
import AdnInputNumber from '../common/adnInputNumber/AdnInputNumber';
import { ExperienceOptions } from '../common/GeneralConfigurations';
import { ProfileDescriptionValidation, PriceValidation, ExperienceValidation } from './memberProfileValidations';

function MemberProfileForm({
    form,
    loading,
    memberProfileData,
    event,
    setEvent,
    visible,
    setVisible,
    submitMemberProfile,
    deleteMemberProfileData,
    totalRecords,
    currPage,
    setCurrPage,
    handleOrderList,
}) {
    const columns = [
        {
            title: 'Profile Description',
            dataIndex: 'profileDescription',
            width: '30%',
            editable: true,
            sorter: (a, b) => a.profileDescription.localeCompare(b.profileDescription),
        },
        {
            title: 'Price',
            dataIndex: 'price',
            width: '30%',
            render: (record) => (
                record.toFixed(2) + " €"
            )
        },
        {
            title: "Experience",
            dataIndex: "experienceName",
            width: "30%",
        },

        {
            title: "Actions",
            key: "action",
            render: (record) => (
                <Space size="middle">
                    <DeleteOutlined
                        style={{ color: "red" }}
                        onClick={() => {
                            adnYesNoModal(() => deleteMemberProfileData(record.id));
                        }}
                    />
                </Space>
            ),
            width: "10%",
        },
    ];

    return (
        <>
            <AdnPageTitle title={"Member Profile "} />
            <AdnCard loading={loading}>
                <AdnAddButton
                    handleClick={() => {
                        setVisible(true);
                        setEvent("add");
                        form.setFieldsValue({ name: "", price: "", experience: undefined });
                    }}
                />

                <Row>
                    <Col span={24}>
                        <AdnTable
                            data={memberProfileData}
                            columns={columns}
                            totalRecords={totalRecords}
                            currentPage={currPage}
                            handleChange={handleOrderList}
                            handleChangePage={setCurrPage}
                        />
                    </Col>
                </Row>
            </AdnCard>
            <Modal
                title={event == "add" ? "New Member Profile" : "Edit Member Profile"}
                open={visible}
                onOk={form.submit}
                cancelText={"Back"}
                okText={"Save"}
                onCancel={() => {
                    setVisible(false);
                }}
            >
                <Form
                    form={form}
                    name="form_in_modal"
                    layout="vertical"
                    onFinish={submitMemberProfile}
                >
                    <AdnInput
                        name={"profileDescription"}
                        label={"Profile Description"}
                        placeholder={"Insert Profile Description"}
                        rules={ProfileDescriptionValidation}
                    />
                    <AdnInputNumber
                        name={"price"}
                        min={2}
                        max={50000000}
                        label={"Price"}
                        placeholder={"Insert Price"}
                        rules={PriceValidation}
                    />
                    <AdnDropdown
                        options={ExperienceOptions}
                        name={"experience"}
                        label={"Experience"}
                        placeholder={"Select Experience"}
                        rules={ExperienceValidation}
                    />
                </Form>
            </Modal>
        </>
    );
}

export default MemberProfileForm;
